<template>
  <div class="form-success">
    <div class="home-logo">
      <img :src="siteData.urlLogo" :style="siteData.stylesLogo">
    </div>
    <h1>{{ $t('formSuccess.title') }}</h1>
    <p>{{ $t('formSuccess.content') }}</p>
  </div>
</template>

<script>
import asyncLoading from './mixins/asyncLoading'
import localeHandler from './mixins/localeHandler'

export default {
  mixins: [ localeHandler, asyncLoading ]
}
</script>

<style>
.home-logo {
  text-align: center;
  max-width: 100%;
}
</style>
